// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"style_sectionWrapper__U3fmO","gradientOverlay":"style_gradientOverlay__WKoex","innerGradient":"style_innerGradient__X7M6_"};